import { saveUpdatedSessionItem } from '../helpers/sessionHelper';
import {
  updateCountryStateInSearch,
  updateAddressInSearch,
  updateCityInSearch,
} from '../reducers/search/searchReducer';
import {
  setDisabledPrevButton,
  setOperation,
  updateSelectedService,
  updateSelectedLanguage,
  updatePage,
} from '../reducers/app/appReducer';
import { type StartAppListeningFunction } from './store';

export const initAppListeners =
  (startAppListening: StartAppListeningFunction) => () => {
    startAppListening({
      actionCreator: updatePage,
      effect: (action) => {
        saveUpdatedSessionItem('page', action.payload);
      },
    });
    startAppListening({
      actionCreator: setOperation,
      effect: (action) => {
        saveUpdatedSessionItem('operation', action.payload);
      },
    });

    startAppListening({
      actionCreator: updateSelectedService,
      effect: (action) => {
        saveUpdatedSessionItem('selected', {
          serviceId: action.payload?.serviceId || '',
          serviceCode: action.payload?.serviceCode || '',
        });
      },
    });

    startAppListening({
      actionCreator: updateSelectedLanguage,
      effect: (action) => {
        saveUpdatedSessionItem('selected', {
          language: action.payload,
        });
      },
    });

    startAppListening({
      actionCreator: updateCountryStateInSearch,
      effect: (action) => {
        saveUpdatedSessionItem('search', { state: action.payload });
      },
    });

    startAppListening({
      actionCreator: updateAddressInSearch,
      effect: (action) => {
        saveUpdatedSessionItem('search', { address: action.payload });
      },
    });

    startAppListening({
      actionCreator: updateCityInSearch,
      effect: (action) => {
        saveUpdatedSessionItem('search', { city: action.payload });
      },
    });

    startAppListening({
      actionCreator: setDisabledPrevButton,
      effect: (action) => {
        saveUpdatedSessionItem('disabledPrevButton', action.payload);
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.app.selected.storeId !==
          previousState.app.selected.storeId
        );
      },
      effect: (_, listenerApi) => {
        saveUpdatedSessionItem('selected', {
          storeId: listenerApi.getState().app.selected.storeId,
        });
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.app.selected.timeSlot !==
          previousState.app.selected.timeSlot
        );
      },
      effect: (_, listenerApi) => {
        saveUpdatedSessionItem('selected', {
          timeSlot: listenerApi.getState().app.selected.timeSlot,
        });
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.app.selected.replacementService?.timeSlot !==
          previousState.app.selected.replacementService?.timeSlot
        );
      },
      effect: (_, listenerApi) => {
        saveUpdatedSessionItem('selected', {
          replacementService:
            listenerApi.getState().app.selected.replacementService,
        });
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return currentState.timeSlots.from !== previousState.timeSlots.from;
      },
      effect: (_, listenerApi) => {
        saveUpdatedSessionItem('from', listenerApi.getState().timeSlots.from);
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return currentState.app.booking !== previousState.app.booking;
      },
      effect: (_, listenerApi) => {
        const { orderNo, ...rest } = listenerApi.getState().app.booking;
        saveUpdatedSessionItem('booking', rest);
        saveUpdatedSessionItem('bookingCompleted', !!orderNo);
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.timeSlots.numberOfWeeksBack.length !==
          previousState.timeSlots.numberOfWeeksBack.length
        );
      },
      effect: (_, listenerApi) => {
        saveUpdatedSessionItem(
          'numberOfWeeksBack',
          listenerApi.getState().timeSlots.numberOfWeeksBack,
        );
      },
    });
  };
